import React from "react";
import { useParams } from "react-router-dom";
import PokemonSetTemplatePage from "./PokemonSetTemplatePage";

export default function PokemonSetRoutePage() {
  const { setSlug } = useParams();
  return <PokemonSetTemplatePage setSlug={setSlug} />;
}
